export default __webpack_public_path__ + "static/media/img-txt.cf9a7838.svg";